export default class AreaEditContenutiListing {
    constructor(node) {
        this.node = node;
        this.deleteConfirmModal = this.node.querySelector('[data-delete-confirm-modal]');
        
        this.addListeners();
    }
    
    addListeners() {
        let _this = this;

        this.node.querySelectorAll('[data-delete-content]').forEach(function(btn) {
            btn.addEventListener('click', function(event) {
                event.preventDefault();
                
                $('#delete-confirm-modal .content-title').html($(this).data("title"));
                _this.deleteConfirmModal.querySelector('[name="coId"]').value = this.dataset.deleteContent;

                $.fancybox.open({
                    src: "#" + _this.deleteConfirmModal.id,
                    type : 'inline',
                    modal:  true,
                });
            });
        });
        
        this.deleteConfirmModal.querySelector('.annulla').addEventListener('click', function(event) {
            event.preventDefault();
            $.fancybox.close(); 
        });
        this.deleteConfirmModal.querySelector('.conferma').addEventListener('click', function(event) {
            document.querySelector('.fancybox-content').classList.add('disabled');
        });

        $(this.deleteConfirmModal.querySelector('form')).validate({
            callbackHandler: function (data, form)
            {
                $.fancybox.close();
                document.querySelector('.fancybox-content').classList.remove('disabled');
                
                if (data.d.Status) {
                    let el = _this.node.querySelector('[data-content="' + data.d.Props.coId + '"]');
                    el.parentNode.removeChild(el);
                }
            }
        });
        
        this.node.querySelectorAll('[data-toggle-active]').forEach(function(toggleNode) {
            toggleNode.addEventListener('click', function(event) {
                event.preventDefault();
                
                $(this).parents('form').submit();
                $(this).parents('.content-card').addClass('busy');
            });
        });
        this.node.querySelectorAll('form.toggle-active').forEach(function(formNode) {
            $(formNode).validate({
                callbackHandler: function (data, form) {
                    let isActive = data.d.Props.isAttivo === "True";
                                        
                    formNode.querySelector('[data-toggle-active]').checked = isActive;

                    let statusText = formNode.querySelector('.status-text');
                    
                    if (isActive) {
                        formNode.querySelector('label').classList.add('checked');
                        statusText.innerHTML = statusText.dataset.activeText;
                    }
                    else {
                        formNode.querySelector('label').classList.remove('checked');
                        statusText.innerHTML = statusText.dataset.disabledText;
                    }
                    
                    $(formNode).parents('.content-card').removeClass('busy');
                }
            });    
        });
    }

    static init() {
        let listingContenuti = document.querySelector("[data-listing-contenuti]");
    
        if (listingContenuti) {
            return new AreaEditContenutiListing(listingContenuti);
        }
    }
}